// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-subscription__container {
    margin-top: 46px;
}

.baloa-pro-subscription__title {
    color: var(--primary-very-dark-color);
    font-size: calc( var(--space-x2) - var(--space-eighth) );
    font-family: 'Lexend Deca';
    font-weight: var(--font-bold);
    letter-spacing: -0.3px;
    text-align: center;
}

.baloa-pro-subscription__buttons {
    display: flex;
    align-items: center;
    margin: 24px 0;
    justify-content: center;
    gap: 10px;
}

.baloa-pro-subscription__buttons .button {
    font-family: 'Lexend Deca';
    padding: var(--space-half-quarter);
}

.baloa-pro-subscription__buttons .secondary-button {
    font-size: calc(var(--space) + var(--space-eighth) + 1px);
    padding: var(--space-half-quarter);
}

.baloa-pro-subscription__message.baloa-username {
    text-align: center;
    color: var(--primary-very-dark-color);
    margin-top: 12px;
}

.baloa-pro-subscription__title-price {
    color: var(--primary-dark-color);
    font-size: 20px;
    font-family: 'Lexend Deca';
    font-weight: var(--font-regular);
    letter-spacing: -0.3px;
    line-height: normal;
    text-align: center;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-pro-subscription__container {
        margin-top: 12px;
        position: sticky;
		bottom: 0;
		background: var(--white-color);
		padding: 10px 0;
    }

    .baloa-pro-subscription__message.baloa-username {
        color: var(--primary-dark-color);
        margin-top: 12px;
        font-size: 13px;
    }

    .baloa-pro-subscription__buttons {
        display: inline-block;
        margin-top: 16px;
        width: 100%;
    }

    .baloa-pro-subscription__buttons .button {
        width: 100%;
        font-size: 14px;
    }

    .baloa-pro-subscription__buttons .secondary-button {
        margin-top: 8px;
        font-size: 14px;
    }

    .baloa-pro-subscription__title {
        font-size: 15px;
    }

    .baloa-pro-subscription__title-price {
        font-size: 13px;
        margin-top: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-subscription/BaloaProSubscriptionComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,wDAAwD;IACxD,0BAA0B;IAC1B,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,yDAAyD;IACzD,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,0BAA0B;IAC1B,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,gBAAgB;QAChB,gBAAgB;EACtB,SAAS;EACT,8BAA8B;EAC9B,eAAe;IACb;;IAEA;QACI,gCAAgC;QAChC,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;AACJ","sourcesContent":[".baloa-pro-subscription__container {\n    margin-top: 46px;\n}\n\n.baloa-pro-subscription__title {\n    color: var(--primary-very-dark-color);\n    font-size: calc( var(--space-x2) - var(--space-eighth) );\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-bold);\n    letter-spacing: -0.3px;\n    text-align: center;\n}\n\n.baloa-pro-subscription__buttons {\n    display: flex;\n    align-items: center;\n    margin: 24px 0;\n    justify-content: center;\n    gap: 10px;\n}\n\n.baloa-pro-subscription__buttons .button {\n    font-family: 'Lexend Deca';\n    padding: var(--space-half-quarter);\n}\n\n.baloa-pro-subscription__buttons .secondary-button {\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);\n    padding: var(--space-half-quarter);\n}\n\n.baloa-pro-subscription__message.baloa-username {\n    text-align: center;\n    color: var(--primary-very-dark-color);\n    margin-top: 12px;\n}\n\n.baloa-pro-subscription__title-price {\n    color: var(--primary-dark-color);\n    font-size: 20px;\n    font-family: 'Lexend Deca';\n    font-weight: var(--font-regular);\n    letter-spacing: -0.3px;\n    line-height: normal;\n    text-align: center;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-pro-subscription__container {\n        margin-top: 12px;\n        position: sticky;\n\t\tbottom: 0;\n\t\tbackground: var(--white-color);\n\t\tpadding: 10px 0;\n    }\n\n    .baloa-pro-subscription__message.baloa-username {\n        color: var(--primary-dark-color);\n        margin-top: 12px;\n        font-size: 13px;\n    }\n\n    .baloa-pro-subscription__buttons {\n        display: inline-block;\n        margin-top: 16px;\n        width: 100%;\n    }\n\n    .baloa-pro-subscription__buttons .button {\n        width: 100%;\n        font-size: 14px;\n    }\n\n    .baloa-pro-subscription__buttons .secondary-button {\n        margin-top: 8px;\n        font-size: 14px;\n    }\n\n    .baloa-pro-subscription__title {\n        font-size: 15px;\n    }\n\n    .baloa-pro-subscription__title-price {\n        font-size: 13px;\n        margin-top: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
